<template>
  <div>
    <div class="grid-row">
      <div class="c-12">
        <h1>{{$_('my_information')}}</h1>
      </div>
    </div>
    <div class="grid-row">
      <div class="c-12">
        <div class="tab-list">
          <div class="tab" @click="vTabSwitch('address')">
            <span>{{$_('my_address')}}</span>
          </div>
          <div class="tab" @click="vTabSwitch('password')">
            <span>{{$_('my_password')}}</span>
          </div>
        </div>
        <div class="tab-content">
          <div class="tab-content-panel" v-if="mode === 'address'">
            <CustomerAddress :mode="'account'" :pnocl="pnocl" />
          </div>
          <div class="tab-content-panel" v-else-if="mode === 'password'">
            <PasswordChange />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CustomerAddress from '@/modules/client/components/CustomerAddress';
import PasswordChange from '@/modules/utilisateur/components/PasswordChange';

export default {
  name: 'Account',
  data() {
    return {
      mode: 'address',
      pnocl: this.$store.getters['application/get_application_customer'].TNCLI
    }
  },
  components: {
    CustomerAddress,
    PasswordChange
  },
  methods: {
    vTabSwitch(mode) {
      this.mode = mode
    }
  }
}
</script>

<style scoped>
.tab-list {
  display: flex;
}
.tab-list .tab {
  padding: 15px 40px 15px 0px;
  border-bottom: solid 2px grey;
}
.tab-list .tab:hover {
  cursor: pointer;
}
.tab-content .tab-content-panel {
  padding: 20px 0px
}
</style>